import { useState } from 'react';
import { useLanguage } from '@/i18n/LanguageContext';
import { api } from '@/App';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Bell, BellOff } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export default function ReminderBell({ enabled, onReminderChange }) {
  const [isEnabled, setIsEnabled] = useState(enabled);
  const [loading, setLoading] = useState(false);
  const { t } = useLanguage();

  const handleToggle = async () => {
    setLoading(true);
    try {
      const newValue = !isEnabled;
      await api.put('/auth/reminder', { reminder_enabled: newValue });
      setIsEnabled(newValue);
      
      if (onReminderChange) {
        onReminderChange(newValue);
      }
      
      toast.success(
        newValue ? t('messages.reminderEnabled') : t('messages.reminderDisabled'),
        { duration: 2000 }
      );
    } catch (error) {
      console.error('Failed to update reminder:', error);
      toast.error(t('messages.operationFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleToggle}
            disabled={loading}
            className="gap-2"
            data-testid="reminder-bell"
          >
            {isEnabled ? (
              <Bell className="h-4 w-4 fill-current" />
            ) : (
              <Bell className="h-4 w-4" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{t('messages.reminderTooltip')}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
